module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', {
    staticClass: "tabbar tabbar-toggleable-md"
  }, [_c('router-link', {
    staticClass: "tabbar-brand",
    attrs: {
      "to": {
        name: 'dashboard'
      }
    }
  }, [_vm._v("\n        Kazoo\n    ")]), _vm._v(" "), _c('ul', {
    staticClass: "tabbar-nav bg-light"
  }, _vm._l((_vm.routes), function(route) {
    return _c('li', {
      staticClass: "tabbar-item"
    }, [_c('router-link', {
      staticClass: "tabbar-link text-dark",
      attrs: {
        "to": route,
        "active-class": "active"
      }
    }, [_c('i', {
      staticClass: "fa tabbar-icon",
      class: route.icon
    }), _vm._v("\n                " + _vm._s(route.title) + "\n            ")])], 1)
  }))], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-386b5335"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Navbar.vue
// module id = 105
// module chunks = 1